export default __webpack_public_path__ + "static/media/service-thumb-brick-masonry.1132b121.jpg";